export default __webpack_public_path__ + "static/media/small_dots_login.4ed8f19c.svg";